<template>
	<div>
		<div>
			<a class="cursor-pointer" @click="$router.go(-1)">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 320 512"
					class="text-bold rotate180 fill-current h-3"
				>
					<path
						d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
					></path>
				</svg>
				{{ $t('back') }}
			</a>
			<h2 class="mb-4 mt-3 font-bold">{{ type }} {{ $t('news_category') }}</h2>
			<div class="mb-4">
				<label class="block mb-2" for="category_name">{{ $t('Nombre') }}</label>
				<input
					type="text"
					v-model="news_category.category_name"
					id="category_name"
					class="
						w-full
						border-t-0
						border-r-0
						border-l-0
						border-b
						border-solid
						border-inputGrey
						outline-none
					"
				/>
				<div v-if="$v.news_category.category_name.$dirty">
					<div
						class="text-sm text-red-500 mt-2"
						v-if="!$v.news_category.category_name.required"
					>
						{{ $t('name_required') }}
					</div>
					<div
						class="text-sm text-red-500 mt-2"
						v-if="!$v.news_category.category_name.maxLength"
					>
						{{ $t('name_validation') }}
					</div>
				</div>
			</div>

			<div class="mb-4">
				<label class="block mb-2" for="currentcountry">País</label>
				<select
					v-model="news_category.country_id"
					class="
						w-full
						border-t-0
						border-r-0
						border-l-0
						border-b
						border-solid
						border-inputGrey
						outline-none
					"
				>
					<option
						v-for="(country, index) in countries"
						:value="country.id"
						:key="index"
					>
						{{ country.name }}
					</option>
				</select>
			</div>

			<div class="mb-4">
				<label class="block mb-2" for="style">{{ $t('Estilo') }}</label>
				<input
					type="color"
					v-model="news_category.style"
					id="style"
					class="
						w-1/6
						border-t-0
						border-r-0
						border-l-0
						border-b
						border-solid
						border-inputGrey
						outline-none
					"
				/>
			</div>

			<h3 class="max-w-md" v-if="image || news_category.image">
				{{
					(image && image.name) ||
					(news_category.image && news_category.image.file_name)
				}}
			</h3>
			<img-upload
				:image="image"
				@upload-image="img_upload"
				@reset-image="img_reset"
			/>
			<div v-if="$v.image.$dirty">
				<div class="text-sm text-red-500 mt-2" v-if="!$v.image">
					{{ $t('image_validation') }}
				</div>
			</div>

			<ButtonBlack class="mt-4" @click.native="submit">
				<div v-if="loading">
					<pulse-loader
						:loading="loading"
						:color="'#fff'"
						:size="'10px'"
					></pulse-loader>
				</div>
				<div v-else>
					{{ buton_text }}
				</div>
			</ButtonBlack>
			<div v-if="error" class="mt-4">
				<p class="text-sm">{{ $t('server_error') }}</p>
				<p class="text-sm text-red-500" v-html="server_error"></p>
			</div>
		</div>
	</div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { single, uploadImage } from '@/mixins'
import ImgUpload from '@/components/ImgUpload.vue'
import { fetchCountriesSelect } from '@/apollo/countries'
import {
	fetchNewsCategory,
	insertNewsCategory,
	updateNewsCategory
} from '@/apollo/newsCategories'

export default {
	mixins: [single, uploadImage],
	components: {
		PulseLoader,
		ImgUpload
	},
	data() {
		return {
			news_category: {
				category_name: '',
				style: '#000000',
				country_id: null,
				image: null
			},
			image: null
		}
	},
	apollo: {
		countries: fetchCountriesSelect(),
		news_category() {
			const query = fetchNewsCategory(this.id)
			query.skip = this.id == null
			return query
		}
	},
	methods: {
		img_reset() {
			this.image ? (this.image = null) : (this.news_category.image = null)
		},
		img_upload(img) {
			this.image = img
		},
		async updateSingleNewsCategory() {
			if (this.image)
				this.news_category.image = await this.uploadImage(
					this.news_category,
					'news_categories',
					this.image
				)
			const mutationData = {
				id: this.id,
				data: this.getNewsCategoryUpdateData()
			}
			await this.$apollo.mutate(updateNewsCategory(mutationData))
		},

		async insertSingleNewsCategory() {
			if (this.image)
				this.news_category.image = await this.uploadImage(
					this.news_category,
					'news_categories',
					this.image
				)
			const mutationData = {
				data: this.getNewsCategoryInsertData()
			}
			await this.$apollo.mutate(insertNewsCategory(mutationData))
		},

		getNewsCategoryUpdateData() {
			return {
				category_name: this.news_category.category_name,
				style: this.news_category.style,
				country_id: this.news_category.country_id,
				image_id: this.news_category.image ? this.news_category.image.id : null
			}
		},

		getNewsCategoryInsertData() {
			return {
				category_name: this.news_category.category_name,
				style: this.news_category.style,
				country_id: this.news_category.country_id,
				image: this.news_category.image
					? { data: this.news_category.image }
					: undefined
			}
		},
		async submit() {
			this.startLoadingState()
			this.$v.$touch()
			if (!this.$v.$invalid) {
				;(this.id
					? this.updateSingleNewsCategory()
					: this.insertSingleNewsCategory()
				)
					.then(() => this.stopLoadingState())
					.catch(error => this.setError(error))
			} else {
				this.setError(this.$t('form_validation'))
			}
		}
	},
	validations() {
		return {
			news_category: {
				category_name: {
					required,
					maxLength: maxLength(50)
				}
			},
			image: function (img) {
				return img || this.bonus.image
			}
		}
	}
}
</script>

<style scoped>
.rotate180 {
	-moz-transform: rotate(-180deg);
	-o-transform: rotate(-180deg);
	-webkit-transform: rotate(-180deg);
	transform: rotate(-180deg);
	display: initial;
	vertical-align: initial;
	margin-right: 5px;
}
</style>
